<template>
  <div class="card-container" :style="{ paddingBottom: paddingBottom + 'px' }">
    <div v-for="(item, index) in cardList" :key="index">
      <div v-if="item.spacing" :style="{ height: item.spacing + 'px' }"></div>
      <div class="top-container" v-if="item.title">
        <div class="title" @click="toJump(item.path)">{{ item.title }}</div>
        <div class="lcon" :style="{ marginLeft: topLeftMargin + 'px' }">
          <slot :name="item.topLeft" v-if="item.topLeft"></slot>
        </div>
        <div class="rcon">
          <slot :name="item.topRight" v-if="item.topRight"></slot>
        </div>
      </div>
      <slot :name="item.name"></slot>
    </div>
  </div>
</template>
<script>
import { useRouter } from "vue-router";
export default {
  name: "tsl-card",
  props: {
    cardList: Array,
    paddingBottom: {
      default: 24,
      type: Number
    },
    topLeftMargin: {
      default: 12,
      type: Number
    }
  },
  setup() {
    const router = useRouter();
    const toJump = (path) => {
      if (path) {
        router.push(path);
      }
    };
    return {
      toJump
    };
  }
};
</script>
<style scoped lang="less">
.card-container {
  margin-bottom: 16px;
  padding: 24px;
  text-align: left;
  background-color: #fff;
  -webkit-border-radius: 4px;
  border-radius: 4px;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
  .top-container {
    display: flex;
    justify-content: space-between;
    .rcon {
      margin-bottom: 14px;
      margin-left: auto;
    }
  }
  .title {
    margin-bottom: 16px;
    color: #1d2129;
    font-weight: 500;
    font-size: 14px;
    line-height: 22px;
  }
}
</style>
